var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "input-wrapper", class: { active: _vm.isActive } },
    [
      _c("span", { staticClass: "placeholder" }, [
        _vm._v(_vm._s(_vm.placeholder)),
      ]),
      _vm._v(" "),
      _vm.hasPriceTag
        ? _c("div", { staticClass: "prc-tag txt-grt ft-xbld" }, [
            _c("span", { staticClass: "b" }, [_vm._v("€")]),
            _vm._v(" "),
            _c("span", { staticClass: "s" }, [
              _vm._v("/" + _vm._s(_vm.priceTagPeriod)),
            ]),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("input", {
        ref: "input",
        attrs: { type: "text", autocomplete: "off", maxlength: _vm.maxChars },
        domProps: { value: _vm.value },
        on: { focus: _vm.focus, blur: _vm.blur, input: _vm.handleInput },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }